import React, { useEffect, useMemo, useState } from 'react';
import { stringToColor } from '../../../utils/avatarUtils';
import { getCompanyLogoUrl, getEmployeeCustomPhotoUrl } from '../../../shared/employees/employeeAvatar';
import './EmployeeAvatar.css';

const EmployeeAvatar = ({
  employee,
  companyData,
  size = 'md',
  className = '',
  alt,
}) => {
  const [photoFailed, setPhotoFailed] = useState(false);
  const [logoFailed, setLogoFailed] = useState(false);

  const customPhoto = getEmployeeCustomPhotoUrl(employee);
  const companyLogoUrl = getCompanyLogoUrl(companyData);
  const displayName =
    alt ||
    employee?.displayName ||
    `${employee?.firstName || ''} ${employee?.lastName || ''}`.trim() ||
    'Employee';
  const initials = useMemo(() => {
    const fromName = `${employee?.firstName?.[0] || ''}${employee?.lastName?.[0] || ''}`
      .trim()
      .toUpperCase();
    return fromName || displayName[0]?.toUpperCase() || '?';
  }, [employee?.firstName, employee?.lastName, displayName]);

  useEffect(() => {
    setPhotoFailed(false);
    setLogoFailed(false);
  }, [customPhoto, companyLogoUrl]);

  const showPhoto = Boolean(customPhoto) && !photoFailed;
  const showLogo = !showPhoto && Boolean(companyLogoUrl) && !logoFailed;
  const showInitials = !showPhoto && !showLogo;
  const isLogo = showLogo;

  return (
    <div
      className={[
        'employee-avatar',
        `employee-avatar--${size}`,
        isLogo ? 'employee-avatar--logo' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden={showInitials ? undefined : true}
    >
      {showPhoto ? (
        <img src={customPhoto} alt="" onError={() => setPhotoFailed(true)} />
      ) : showLogo ? (
        <img src={companyLogoUrl} alt="" onError={() => setLogoFailed(true)} />
      ) : (
        <span
          className="employee-avatar__initials"
          style={{ backgroundColor: stringToColor(displayName) }}
        >
          {initials}
        </span>
      )}
    </div>
  );
};

export default EmployeeAvatar;
